// @flow
import React from 'react';
import { withRouter } from 'react-router-dom';
import { RouteUtil } from 'utils/RouteUtil';
import architectureImage from 'assets/images/architecture.jpg';
import hamburgerWhiteIcon from 'assets/images/ham-white.png';
import squirrelWhiteIcon from 'assets/images/squirrelWhite.svg';
import { CallToAction } from 'components/atoms/callToAction';
import { useViewport } from 'components/templates/viewportProvider';

type Props = {
  history: Object,
};

const NotFoundPage = (props: Props) => {
  const onClick = () => {
    RouteUtil.setRouteChange(props, '/');
  };

  const { isMobile } = useViewport();

  return (
    <div className={`section error-page ${isMobile ? 'mobile' : ''}`}>
      <img
        src={architectureImage}
        alt={'Background'}
        className={'background'}
      />
      <div className={'section-header'}>
        <div className={'icon-container'}>
          <img src={hamburgerWhiteIcon} alt={'icon'} />
        </div>
        <div className={'logo-container'}>
          <strong>Total</strong>Environment
        </div>
      </div>
      <div className={'section-container'}>
        <h1 className={'big-counter'}>404</h1>
        <h2>page not found</h2>
        <p>Looks like the page you are looking for is invalid or has moved</p>
        <CallToAction
          text={'Take me Home'}
          onClick={onClick}
          mode={'transparent'}
          type={'link'}
          isMobile={true}
        />
      </div>
      <div className={'section-footer'}>
        <div className={'icon-container'}>
          <img src={squirrelWhiteIcon} alt={'icon'} />
        </div>
      </div>
    </div>
  );
};

export default withRouter(NotFoundPage);
